<template>
  <div class="content_all2" id="forpass">
    <div class="content_box">
      <div class="list_box w500">
        <div class="y_ititle"><i class="fa fa-lock mr5" aria-hidden="true"></i>忘記密碼</div>
        <div class="mt5 mb5">
          <input name="" type="text" class="input_style" placeholder="輸入申請人　帳號 " v-model="account">
        </div>
        <div class="mt5 mb5">
          <input name="" type="text" class="input_style" placeholder="輸入申請人 email " v-model="email">
        </div>
        <div class="mt5 mb5">
          <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
        </div>
        <div class="tomi mt15">
          <button type="submit" class="btn_m" @click="changePassword">送出</button>
          <button type="submit" class="btn_n" @click="goBack">回上一頁</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API } from '@/assets/project_setting/config';
import { ShowMessage, Message, RentStatusCode } from '@/assets/library/axiosErrorHandler';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'forpass',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      account: '',
      email: '',
      verifycode: ''
    };
  },

  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
      console.log(this.verifycode)
    },
    goBack() {
      // window.window.history.go(-1)
      window.history.go(-1)
      
    },

    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    checkAccount() {
      if (!this.account) {
        throw new Error('請輸入帳號');
      }
    },
    checkEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.email) {
        throw new Error('請輸入電子信箱');
      }
      if (this.email && !this.email.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },
    changePassword() {

      try {
        this.checkAccount()
        this.checkEmail();
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }
      let query = `?email=${this.email}&account=${this.account}`;
      axios.delete(API.rent_password + query)
        .then(response => {
          alert('請在五分鐘內至信箱收信完成更改密碼');
        })
        .catch(error => {
          //例外處理
          let statusCode = parseInt(error.response.data.statusCode);
          for (let props in RentStatusCode) {
            if (statusCode === RentStatusCode[props]) {
              ShowMessage(Message[props][sessionStorage.locale]);
            }
          }
        });
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// Forpass.vue?7cced14e